import { ObjectType } from '../Types/base';
import { BizEngageType } from '../Types/engage';
import { post, postOnUnload } from './common';

const engageEndpoint = 'api/Engage';
const eventStatisticsEndpoint = 'api/eventstatistics';

// export enum EngageObjectType {
// 	MediabankFile = 'MediabankFile',
// }

export enum EngageStatus {
	Started = 1,
	Cancelled = 2,
	Finished = 3,
	Failed = 5,
}

export async function logUserStatus(objectId?: number, objectType?: ObjectType, status?: EngageStatus, passed?: boolean) {
	return __logUserStatus(objectId, mapObjectTypeToEngageObject(objectType), status, passed);
}

export async function __logUserStatus(objectId?: number, objectType?: BizEngageType, status?: EngageStatus, passed?: boolean) {
	if (!objectId || !objectType || !status) {
		return;
	}
	const params = new URLSearchParams({
		objectId: objectId.toString(),
		objectType: objectType as number as unknown as string, // Cast to number first to get the numeric value, then to string
		status: status.toString(),
		passed: passed ? 'true' : 'false',
	});
	return await post(`${engageEndpoint}/LogUserStatus?${params.toString()}`);
}

export function logUserStatusOnUnload(objectId?: number, objectType?: ObjectType, status?: EngageStatus) {
	return __logUserStatusOnUnload(objectId, mapObjectTypeToEngageObject(objectType), status);
}

export function __logUserStatusOnUnload(objectId?: number, objectType?: BizEngageType, status?: EngageStatus) {
	if (!objectId || !objectType || !status) {
		return;
	}
	const params = new URLSearchParams({
		objectId: objectId.toString(),
		objectType: objectType as number as unknown as string, // Cast to number first to get the numeric value, then to string
		status: status.toString(),
		passed: 'false',
	});
	postOnUnload(`${engageEndpoint}/LogUserStatus?${params.toString()}`);
}

export async function eventStart(objectId: number, eventType: number, eventSource?: string | ObjectType) {
	return await post(`${eventStatisticsEndpoint}/EventStart`, {
		objectId,
		eventType,
		eventSource: mapObjectTypeToEventSource(eventSource),
		url: window.location.href,
	});
}

export async function eventEnd(objectId: number, eventType: number, eventSource?: string | ObjectType) {
	return await post(`${eventStatisticsEndpoint}/EventEnd`, {
		objectId,
		eventType,
		eventSource: mapObjectTypeToEventSource(eventSource),
		url: window.location.href,
	});
}

function mapObjectTypeToEngageObject(objectType?: ObjectType): BizEngageType | undefined {
	switch (objectType) {
		case ObjectType.BlogPost:
			return BizEngageType.Blog;
		case ObjectType.OnlineEducation:
			return BizEngageType.Education;
		case ObjectType.MediabankFile:
			return BizEngageType.Video;
		case ObjectType.Quiz:
			return BizEngageType.Speedquiz;
		case ObjectType.Certification:
			return BizEngageType.Certification;
		case ObjectType.Event:
			return BizEngageType.Event;
		default:
			return undefined;
	}
}

function mapObjectTypeToEventSource(objectType?: ObjectType | string): string | undefined {
	if (!objectType) {
		return undefined;
	}

	if (typeof objectType === 'string') {
		return objectType;
	}
	switch (objectType) {
		case ObjectType.MediabankFile:
			return 'MEDIA';
		case ObjectType.BlogPost:
			return 'BLOG';
		case ObjectType.OnlineEducation:
			return 'HTML5';
		default:
			return undefined;
	}
}
